<template>
<nav class="custom-nav">
        <Dropdown title="ΥΠΗΡΕΣΙΕΣ" :items="services"/>
</nav>
</template>

<script>
import Dropdown from './Dropdown'

export default{
    name: 'white-navbar',
    components: {
        Dropdown
    },
     data () {
        return{
            services: [
                {
                    title: 'Λαπαροσκοπική Χειρουργική',
                    link: '/laparoskopiki-xeirourgiki/'
                },
                {
                    title: 'Πρωκτολογία',
                    link: '/proktologia/'
                },
                {
                    title: 'Χειρουργική Κηλών',
                    link: '/xeirourgiki-kilon/'
                },
                {
                    title: 'Κύστη Κόκκυγος',
                    link:'/kisti-kokkigos/'
                },
                {
                    title: 'Αφαίρεση Ραμμάτων',
                    link:'/aferesi-ramaton/'
                },             
                {
                    title: 'Αιμορροΐδες',
                    link:'/aimoroides'
                }                 
            ],
        }
    }

}
</script>
<style >
 nav{
        display: flex;
        align-items: center;
    }

    nav .menu-item{
        color:#fff;
        position: relative;
        text-align:center;
        border-bottom: 3px solid transparent;
        display: flex;
        transition: 0.4s;
    }

    nav .menu-item a{
        color:inherit;
        text-decoration:none;
    }
</style>